<div
    class="listing-status-cell"
    [class.type-icon]="statusDisplayType() === DistributionStatusBarTypeEnum.ICON"
    [class.type-progress]="statusDisplayType() === DistributionStatusBarTypeEnum.BAR"
>
    @let issueCount = listingWarnings().length + listingErrors().length;

    @if (statusDisplayType() === DistributionStatusBarTypeEnum.BAR) {
        <div class="export-status-wrapper">
            <div class="progress-bar-container">
                <div class="progress-bar">
                    <div class="progress-bar-fill" [ngStyle]="{ 'width.%': displayPercentage() }"></div>
                </div>
                <span>{{ displayPercentage() }}%</span>
            </div>
            @if (shouldShowAssetCounts()) {
                <div class="exported-asset-count-container">
                    <span>{{
                        'visuals.visualsTab.imageTracker.table.status.subtitle'
                            | translate: { exportedCount: exportedCount(), eligibleCount: eligibleCount() }
                    }}</span>
                </div>
            }
        </div>
        @if (listingWarnings() && listingWarnings().length) {
            <div
                class="statusWrapper warning listing-warning"
                appTooltip
                trigger="hover"
                position="right"
                [component]="listingStatusTooltip"
                [componentData]="listingStatusIconTooltipData()"
                [showDelay]="200"
                [hideDelay]="200"
            >
                @if (issueCount > 1) {
                    <div class="warning-count-banner">
                        <span>{{ issueCount }}</span>
                    </div>
                }
                <i class="fa fa-lg fa-exclamation-triangle"></i>
            </div>
        }
    } @else {
        <div
            class="statusWrapper"
            [class.unknown]="imageTrackerWarningType() === ImageTrackerStatusType.UNKNOWN"
            [class.failed]="imageTrackerWarningType() === ImageTrackerStatusType.FAILED"
            [class.skipped]="imageTrackerWarningType() === ImageTrackerStatusType.SKIPPED"
            [class.warning]="imageTrackerWarningType() === ImageTrackerStatusType.EXPORTED_WITH_WARNINGS"
            [class.successful]="imageTrackerWarningType() === ImageTrackerStatusType.SUCCESSFUL"
            appTooltip
            trigger="hover"
            position="right"
            [component]="listingStatusTooltip"
            [componentData]="listingStatusIconTooltipData()"
            [showDelay]="200"
            [hideDelay]="200"
        >
            @if (issueCount > 1) {
                <div class="warning-count-banner">
                    <span>{{ issueCount }}</span>
                </div>
            }
            @switch (imageTrackerWarningType()) {
                @case (ImageTrackerStatusType.UNKNOWN) {
                    <i class="fa fa-lg fa-question"></i>
                }
                @case (ImageTrackerStatusType.FAILED) {
                    <i class="fa fa-lg fa-xmark"></i>
                }
                @case (ImageTrackerStatusType.SKIPPED) {
                    <i class="fa fa-chevrons-right"></i>
                }
                @case (ImageTrackerStatusType.EXPORTED_WITH_WARNINGS) {
                    <i class="fa fa-lg fa-warning-triangle"></i>
                }
                @case (ImageTrackerStatusType.SUCCESSFUL) {
                    <i class="fa fa-lg fa-check"></i>
                }
            }
        </div>
    }
</div>
